import React from 'react'

import {track, TrackingEvent} from '@helios/shared/utils/analytics'

import type {ExpenseReportGeneratorVariant} from './types'

type Action = 'first_interaction'

export const useTrackFirstInteraction = (variant: ExpenseReportGeneratorVariant) => {
    const [hasInteracted, setHasInteracted] = React.useState(false)

    return (action: Action) => {
        // If we've already tracked, do nothing
        if (hasInteracted) {
            return
        }

        // Track first interaction
        track(TrackingEvent.ERGActioned, {
            action,
            variant,
        })

        setHasInteracted(true)
    }
}
